import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

//读任务
export const requestNoReadTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/noreadtasklist`, params: params });
return res.data; };
export const requestreadtask = async params => { const res = await axios({ method: 'post', url: `${base}/project/readtask`, params: params });
return res.data; };
export const requestReadAll = async params => { const res = await axios({ method: 'post', url: `${base}/project/readall`, params: params });
return res.data; };

export const requestGjcsTj = async params => { const res = await axios({ method: 'post', url: `${base}/tj/gjcstj`, params: params });
return res.data; };
export const requestprojectloglikeat = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectloglikeat`, params: params });
return res.data; };
export const requestWeekTj = async params => { const res = await axios({ method: 'post', url: `${base}/tj/weektj`, params: params });
return res.data; };
export const requestUpdatePlandate = async params => { const res = await axios({ method: 'post', url: `${base}/project/updateplandate`, params: params });
return res.data; };
export const requestGetWeekList = async params => { const res = await axios({ method: 'post', url: `${base}/project/getweeklist`, params: params });
return res.data; };
export const requestProjectWeek = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectweek`, params: params });
return res.data; };
// 创建项目
export const requestProjectLogDayList = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectlogdaylist`, params: params });
return res.data; };
export const requestProjectLog = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectlog`, params: params });
return res.data; };
export const requestProjectAllList = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectalllist`, params: params });
return res.data; };
export const requestAddProject = async params => { const res = await axios({ method: 'post', url: `${base}/project/addproject`, params: params });
return res.data; };
// 项目列表
export const requestProjectList = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectlist`, params: params });
return res.data; };
//项目所有附件（汇总项目信息/项目日志/任务/任务日志/签字流程/建模/周计划/数据收集）
export const requestProjectAllFiles = async params => { const res = await axios({ method: 'post', url: `${base}/project/allfiles`, params: params });
return res.data; };
//人员列表
export const xmUser = async params => { const res = await axios({ method: 'post', url: `${base}/project/userlist`, params: params });
return res.data; };
//项目详情
export const xmDetails = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectdetails`, params: params });
return res.data; };
export const xmDetails2 = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectdetails2`, params: params });
return res.data; };
export const requestSaveProjectFp = async params => { const res = await axios({ method: 'post', url: `${base}/project/savefp`, params: params });
return res.data; };
export const requestDDDepartlist = async params => { const res = await axios({ method: 'post', url: `${base}/project/getdddepart`, params: params });
return res.data; };
//添加任务
export const requestAddTaskpj = async params => { const res = await axios({ method: 'post', url: `${base}/project/addtaskpj`, params: params });
return res.data; };
export const requestAddTask = async params => { const res = await axios({ method: 'post', url: `${base}/project/addtask`, params: params });
return res.data; };
//修改计划完成时间
export const requestUpdatePlanEndTime = async params => { const res = await axios({ method: 'post', url: `${base}/project/updateplanendtime`, params: params });
return res.data; };
export const requestUpdateTaskDate = async params => { const res = await axios({ method: 'post', url: `${base}/project/updatetaskdate`, params: params });
return res.data; };
//更新任务完成百分比
export const requestUpdateFinishPercent = async params => { const res = await axios({ method: 'post', url: `${base}/project/updatefinishpercent`, params: params });
return res.data; };
export const requestPriority = async params => { const res = await axios({ method: 'post', url: `${base}/project/updatepriority`, params: params });
return res.data; };
export const requestIsAddOtherOs = async params => { const res = await axios({ method: 'post', url: `${base}/project/updateaddotheros`, params: params });
return res.data; };
//更新是否加急
export const requestIsUrgent = async params => { const res = await axios({ method: 'post', url: `${base}/project/updateisurgent`, params: params });
return res.data; };
//更新"执行人是否能按时按要求完成"判定（ontimeflag:1可以/2不能，ontimereason:不能时的原因）
export const requestUpdateOnTime = async params => { const res = await axios({ method: 'post', url: `${base}/project/updateontime`, params: params });
return res.data; };
//"按时按要求完成"提醒列表：我创建的、判定为未判定或不能的任务
export const requestMyOntimeTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/myontimetasklist`, params: params });
return res.data; };
//部门树（含 parent_id 层级，用于部门层级筛选）
export const requestDDDepartTree = async params => { const res = await axios({ method: 'post', url: `${base}/project/getdddeparttree`, params: params });
return res.data; };
//更新"任务是否汇报"状态（reportflag:1汇报/0取消汇报）
export const requestUpdateReport = async params => { const res = await axios({ method: 'post', url: `${base}/project/updatereport`, params: params });
return res.data; };
//任务列表
export const requestTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/tasklist`, params: params });
return res.data; };
export const requestAllTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/alltasklist`, params: params });
return res.data; };
//甘特图任务列表（项目下全部非关闭任务）
export const requestTaskGanttList = async params => { const res = await axios({ method: 'post', url: `${base}/project/taskganttlist`, params: params });
return res.data; };

//任务状态
export const requestTaskStatus = async params => { const res = await axios({ method: 'post', url: `${base}/project/editstatus`, params: params });
return res.data; };
//当前登录用户是否有"启动任务"权限
export const requestGetSelfStartPerm = async params => { const res = await axios({ method: 'post', url: `${base}/project/getselfstartperm`, params: params });
return res.data; };
//执行人是我的任务列表
export const requestMyTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/selftask`, params: params });
return res.data; };
//审核人是我的任务列表
export const requestMyShrTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/shrtask`, params: params });
return res.data; };
//启动人是我的（待启动）任务列表
export const requestMyStartTaskList = async params => { const res = await axios({ method: 'post', url: `${base}/project/starttask`, params: params });
return res.data; };
//任务回复
export const requestAddTasklog = async params => { const res = await axios({ method: 'post', url: `${base}/project/addtasklog`, params: params });
return res.data; };
// 回复列表
export const requestTasklogList = async params => { const res = await axios({ method: 'post', url: `${base}/project/taskloglist`, params: params });
return res.data; };
//设置任务是否显示在执行人工作台待处理列表（show: 1显示 / 0不显示）
export const requestSetWorkbenchShow = async params => { const res = await axios({ method: 'post', url: `${base}/project/setworkbenchshow`, params: params });
return res.data; };
//作废任务日志（保留日志，标记作废并记录原因，作废操作同时记入日志）
export const requestVoidTaskLog = async params => { const res = await axios({ method: 'post', url: `${base}/project/voidtasklog`, params: params });
return res.data; };
//作废附件（scopetype: task=任务附件 step=签字流程节点附件）
export const requestVoidTaskFile = async params => { const res = await axios({ method: 'post', url: `${base}/project/voidtaskfile`, params: params });
return res.data; };
//查询任务下已作废的附件
export const requestVoidFileList = async params => { const res = await axios({ method: 'post', url: `${base}/project/voidfilelist`, params: params });
return res.data; };
//提交项目日志
export const requestAddProjectlog = async params => { const res = await axios({ method: 'post', url: `${base}/project/addprojectlog`, params: params });
return res.data; };
// 项目日志列表
export const requestProjectlogList = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectloglist`, params: params });
return res.data; };
//用户逾期列表
export const requestYuqiUserList = async params => { const res = await axios({ method: 'post', url: `${base}/project/yuqitaskuser`, params: params });
return res.data; };
//用户逾期-任务明细列表
export const requestYuqiTaskUserList = async params => { const res = await axios({ method: 'post', url: `${base}/project/yuqitaskuserlist`, params: params });
return res.data; };
export const requestJlrw = async params => { const res = await axios({ method: 'post', url: `${base}/tj/jlrwtj`, params: params });
return res.data; };
//获取项目节点信息
export const requestGetProjectStep = async params => { const res = await axios({ method: 'post', url: `${base}/project/getprojectstep`, params: params });
return res.data; };
//修改项目节点时间
export const requestSetProjectStepDate = async params => { const res = await axios({ method: 'post', url: `${base}/project/setprojectstepdate`, params: params });
return res.data; };
//修改项目节点负责人
export const requestSetProjectStepOperator = async params => { const res = await axios({ method: 'post', url: `${base}/project/setprojectstepoperator`, params: params });
return res.data; };
//节点状态
export const requestProjectStepStatusList = async params => { const res = await axios({ method: 'post', url: `${base}/project/projectstepstatuslist`, params: params });
return res.data; };
//通过taskid查询task信息
export const requestTaskInfoById = async params => { const res = await axios({ method: 'post', url: `${base}/project/taskinfobyid`, params: params });
return res.data; };
///project/gettaskpidlist  查询子节点
export const requestGetTaskPidList = async params => { const res = await axios({ method: 'post', url: `${base}/project/gettaskpidlist`, params: params });
return res.data; };
export const requestBd = async params => { const res = await axios({ method: 'post', url: `${base}/project/bd`, params: params });
return res.data; };
export const requestUpdateBd = async params => { const res = await axios({ method: 'post', url: `${base}/project/savebd`, params: params });
return res.data; };
export const requestBdList = async params => { const res = await axios({ method: 'post', url: `${base}/bd/bdlist`, params: params });
return res.data; };
export const requestSelfBdList = async params => { const res = await axios({ method: 'post', url: `${base}/bd/selfbdlist`, params: params });
return res.data; };
export const requestTaskDate = async params => { const res = await axios({ method: 'post', url: `${base}/project/taskdate`, params: params });
return res.data; };
export const requestTaskDayList = async params => { const res = await axios({ method: 'post', url: `${base}/project/taskdaylist`, params: params });
return res.data; };
export const requestTaskLogDate = async params => { const res = await axios({ method: 'post', url: `${base}/project/tasklogdate`, params: params });
return res.data; };
export const requestTaskLogDayList = async params => { const res = await axios({ method: 'post', url: `${base}/project/tasklogdaylist`, params: params });
return res.data; };
export const requestTaskqz = async params => { const res = await axios({ method: 'post', url: `${base}/project/qz`, params: params });
return res.data; };
export const requestTaskgjcs = async params => { const res = await axios({ method: 'post', url: `${base}/project/savegjcs`, params: params });
return res.data; };
export const requestSaveSubTask = async params => { const res = await axios({ method: 'post', url: `${base}/project/savesubtaskinfo`, params: params });
return res.data; };
export const requestCheckSubTaskInfo = async params => { const res = await axios({ method: 'post', url: `${base}/project/checksubtaskinfo`, params: params });
return res.data; };
export const requestDeleteSubTaskInfo = async params => { const res = await axios({ method: 'post', url: `${base}/project/deletesubtaskinfo`, params: params });
return res.data; };
export const requestGetSubTaskInfo = async params => { const res = await axios({ method: 'post', url: `${base}/project/getsubtaskinfo`, params: params });
return res.data; };
export const requestModelingList = async params => { const res = await axios({ method: 'post', url: `${base}/modeling/list`, params: params });
return res.data; };
export const requestModelingedit = async params => { const res = await axios({ method: 'post', url: `${base}/modeling/edit`, params: params });
return res.data; };
export const requestModelingdel = async params => { const res = await axios({ method: 'post', url: `${base}/modeling/del`, params: params });
return res.data; };
export const requestModelingfindbyid = async params => { const res = await axios({ method: 'post', url: `${base}/modeling/findbyid`, params: params });
return res.data; };
export const requestModlingmydById =async params => { const res = await axios({ method: 'post', url: `${base}/modeling/updatemydbyid`, params: params });
return res.data; };
export const requestModelingTj =async params => { const res = await axios({ method: 'post', url: `${base}/modeling/modelingtj`, params: params });
return res.data; };
export const requestprojectstatus =async params => { const res = await axios({ method: 'post', url: `${base}/projectstatus/alllist`, params: params });
return res.data; };
export const requestJlrwhz =async params => { const res = await axios({ method: 'post', url: `${base}/tj/jlrwhz`, params: params });
return res.data; };
export const requestDerwhz = async params => { const res = await axios({ method: 'post', url: `${base}/tj/derwtj`, params: params });
return res.data; };
export const requestDerwmxlist = async params => { const res = await axios({ method: 'post', url: `${base}/tj/derwmxlist`, params: params });
return res.data; };
// 月度任务统计：按部门(含下级)统计每个人当月 status=完成 的执行人任务数量
export const requestMonthTaskStat = async params => { const res = await axios({ method: 'post', url: `${base}/tj/monthtaskstat`, params: params });
return res.data; };
// 月度任务导出：导出部门(含下级)下指定用户当月 status=完成 的任务明细
export const requestMonthTaskExport = async params => { const res = await axios({ method: 'post', url: `${base}/tj/monthtaskexport`, params: params });
return res.data; };
// 月度任务：获取部门(含下级)下所有人员，用于执行人下拉
export const requestMonthTaskUsers = async params => { const res = await axios({ method: 'post', url: `${base}/tj/monthtaskusers`, params: params });
return res.data; };
//任务提醒配置
export const requestSaveTaskReminder = async params => { const res = await axios({ method: 'post', url: `${base}/project/savetaskreminder`, params: params });
return res.data; };
export const requestGetTaskReminderList = async params => { const res = await axios({ method: 'post', url: `${base}/project/gettaskreminderlist`, params: params });
return res.data; };
export const requestDeleteTaskReminder = async params => { const res = await axios({ method: 'post', url: `${base}/project/deletetaskreminder`, params: params });
return res.data; };
export const requestMarkReminderRead = async params => { const res = await axios({ method: 'post', url: `${base}/project/markreminderread`, params: params });
return res.data; };
export const requestGetUnreadReminderList = async params => { const res = await axios({ method: 'post', url: `${base}/project/getunreadreminderlist`, params: params });
return res.data; };
//项目日志
export const requestSaveProjectLogInfo = async params => { const res = await axios({ method: 'post', url: `${base}/project/saveprojectloginfo`, params: params });
return res.data; };
export const requestGetProjectLogInfoList = async params => { const res = await axios({ method: 'post', url: `${base}/project/getprojectloginfolist`, params: params });
return res.data; };
export const requestMarkProjectLogRead = async params => { const res = await axios({ method: 'post', url: `${base}/project/markprojectlogread`, params: params });
return res.data; };
export const requestGetUnreadProjectLogList = async params => { const res = await axios({ method: 'post', url: `${base}/project/getunreadprojectloglist`, params: params });
return res.data; };
export const requestGetProjectLogReadStatus = async params => { const res = await axios({ method: 'post', url: `${base}/project/getprojectlogreadstatus`, params: params });
return res.data; };
export const requestProcessProjectLog = async params => { const res = await axios({ method: 'post', url: `${base}/project/processprojectlog`, params: params });
return res.data; };
// 保存要求上传文件
export const requestSaveRequiredFiles = async params => { const res = await axios({ method: 'post', url: `${base}/project/saverequiredfiles`, params: params });
return res.data; };